// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_gheKk {
  padding: 0px 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.clientsHeader__aS1e {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
  padding: 10px 10px 0px;
  width: 95%;
}
.infoClient_qii41 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  h3,
  h2,
  p {
    margin: 0;
    color: black;
  }
  h3 {
    font-weight: bold;
    font-size: 22px;
  }
  p {
    font-weight: bold;
  }
}
.arrowContainer_ypUuA {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}
.iconContainer_g2iKh {
  border: none;
  outline: none;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 4px;
  display: flex;
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  align-items: center;
  justify-content: center;
  height: fit-content;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
}
.clientInfo_kziZi {
  display: flex;
  flex-direction: column;
}
.contactInfo_V39rx,
.info_wA4oE {
  display: flex;
  gap: 10px;
  align-items: center;
  white-space: nowrap;
}

.info_wA4oE p {
  margin-left: 10px; 
}

.info_wA4oE p:first-child {
  margin-left: 0; 
}

.contactInfo_V39rx {
  flex-wrap: wrap;
}

.searchContainer_cuzAo {
  display: flex;
  align-items: center;
  gap: 20px;
  .button_WKOzs {
    text-decoration: underline;
    cursor: pointer;
    color: var(--_2-color);
    min-width: fit-content;
  }
}
.imgContainer_xLk6W {
  img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
  }
}

.rowState_bqLwP {
  font-size: 15px;

  span {
    font-weight: bold;
    color: var(--009f7a-color);
    margin-right: 5px;
  }
}

.searchContainer_cuzAo {
  display: flex;
  align-items: center;
  gap: 20px;

  .inputWrapper_CGKhI {
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 0 10px 10px 0;

    .searchInput_fuM32 {
      padding: 10px 10px 10px 35px;
      border: 1px solid #ccc;
      border-radius: 10px;
      font-size: 16px;
      outline: none;
      width: 250px;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      -ms-border-radius: 10px;
      -o-border-radius: 10px;

      &::placeholder {
        color: #aaa;
      }
    }
  }
}



.searchIconsWrappers_D6HA5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}



.addButton_UfDv5 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  width: 40px;
  background-color: #233f39;
  color: var(--white-color);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;

  img {
    width: 15px;
    height: 15px;
  }

  &:hover {
    background-color: #122521;
  }
}

.table_bofZt {
  width: 100%;
  text-align: start;
  border-collapse: collapse;
  tbody {
    td {
      padding: 10px;
      color: #666666;
      font-size: 13px;
      p {
        margin: 0;
        &:first-of-type {
          margin-bottom: 0px;
        }
      }
    }
  }

  thead {
    th {
      text-align: start;
      padding: 10px;
      color: #333;
      font-weight: bold;
      width: 150px;
      min-width: 120px;
    }
  }
}

.name_F4n_4 {
  color: #333333;
  font-weight: 600;
}



.small_YvEnD {
  min-width: 40px;
  width: 40px;
}

.actions_q47kF {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  img {
    cursor: pointer;
  }
}

.transacciones_yhqE9 {
  display: flex;
  flex-direction: column;
  gap: 3px;

  a {
    font-weight: bold;
    text-decoration: none;
  }

  span {
    text-decoration: underline;
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

.bg_tsWV_ {
  background-color: var(--_00000020-background);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.newClientContainer_YIuwh {
  position: fixed;
  background-color: var(--white-color);
  padding-bottom: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 80vh;
  width: 80%;
  overflow-y: scroll;
  border-radius: 10px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;






  .row_wmnfp {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  p {
    color: var(--black-color);
    font-weight: 500;
    margin: 0;
  }

  .plan_HKTrY {
    padding-right: 30px;

    span {
      color: var(--black-color);
    }
  }

  .inputContainer_uE7C1 {
    position: relative;
    display: flex;
    align-items: center;
  }

  .input_nsLgK {
    width: 100%;
    padding-right: 40px;
    box-sizing: border-box;
  }

  .icon_Trtmt {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 20px;
    pointer-events: none;
  }

  label {
    display: flex;
    flex-direction: column;
    color: #717171;
    gap: 8px;
    margin-bottom: 30px;
    padding: 10px 0;
    border-bottom: 1px solid #ebebeb;

    input,
    select,
    option {
      padding: 10px;
      border: none;
      outline: none;
      background-color: var(--f5-background);
      border-radius: 4px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      -ms-border-radius: 4px;
      -o-border-radius: 4px;
    }

    select,
    option {
      color: var(--_75-color);
    }
  }



  .btnOptionsContainer_rPAT1 {
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    gap: 10px;

    button {
      padding: 10px 20px;
      border-radius: 8px;
      text-decoration: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
    }

  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    text-decoration: underline;
    color: var(--black-color);
    font-weight: 600;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ArticlesTransactions/ArticlesTransactions.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;;;IAGE,SAAS;IACT,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;;EAEf;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;;IAE5B;MACE,4BAA4B;MAC5B,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;MACf,aAAa;MACb,YAAY;MACZ,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;;MAEtB;QACE,WAAW;MACb;IACF;EACF;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB;IACE;MACE,aAAa;MACb,cAAc;MACd,eAAe;MACf;QACE,SAAS;QACT;UACE,kBAAkB;QACpB;MACF;IACF;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,aAAa;MACb,WAAW;MACX,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;;AAIA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;;EAET;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;;;;;;EAOtB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,mBAAmB;;IAEnB;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gCAAgC;;IAEhC;;;MAGE,aAAa;MACb,YAAY;MACZ,aAAa;MACb,sCAAsC;MACtC,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;;MAEE,uBAAuB;IACzB;EACF;;;;EAIA;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;;IAET;MACE,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;EAEF;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".container {\n  padding: 0px 10px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.clientsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 10px;\n  padding: 10px 10px 0px;\n  width: 95%;\n}\n.infoClient {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  h3,\n  h2,\n  p {\n    margin: 0;\n    color: black;\n  }\n  h3 {\n    font-weight: bold;\n    font-size: 22px;\n  }\n  p {\n    font-weight: bold;\n  }\n}\n.arrowContainer {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.iconContainer {\n  border: none;\n  outline: none;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 4px;\n  display: flex;\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  box-sizing: border-box;\n  height: 25px;\n  width: 25px;\n}\n.clientInfo {\n  display: flex;\n  flex-direction: column;\n}\n.contactInfo,\n.info {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.info p {\n  margin-left: 10px; \n}\n\n.info p:first-child {\n  margin-left: 0; \n}\n\n.contactInfo {\n  flex-wrap: wrap;\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  .button {\n    text-decoration: underline;\n    cursor: pointer;\n    color: var(--_2-color);\n    min-width: fit-content;\n  }\n}\n.imgContainer {\n  img {\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n  }\n}\n\n.rowState {\n  font-size: 15px;\n\n  span {\n    font-weight: bold;\n    color: var(--009f7a-color);\n    margin-right: 5px;\n  }\n}\n\n.searchContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n\n  .inputWrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 40px;\n    border-radius: 0 10px 10px 0;\n\n    .searchInput {\n      padding: 10px 10px 10px 35px;\n      border: 1px solid #ccc;\n      border-radius: 10px;\n      font-size: 16px;\n      outline: none;\n      width: 250px;\n      -webkit-border-radius: 10px;\n      -moz-border-radius: 10px;\n      -ms-border-radius: 10px;\n      -o-border-radius: 10px;\n\n      &::placeholder {\n        color: #aaa;\n      }\n    }\n  }\n}\n\n\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n\n\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  width: 40px;\n  background-color: #233f39;\n  color: var(--white-color);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n\n  img {\n    width: 15px;\n    height: 15px;\n  }\n\n  &:hover {\n    background-color: #122521;\n  }\n}\n\n.table {\n  width: 100%;\n  text-align: start;\n  border-collapse: collapse;\n  tbody {\n    td {\n      padding: 10px;\n      color: #666666;\n      font-size: 13px;\n      p {\n        margin: 0;\n        &:first-of-type {\n          margin-bottom: 0px;\n        }\n      }\n    }\n  }\n\n  thead {\n    th {\n      text-align: start;\n      padding: 10px;\n      color: #333;\n      font-weight: bold;\n      width: 150px;\n      min-width: 120px;\n    }\n  }\n}\n\n.name {\n  color: #333333;\n  font-weight: 600;\n}\n\n\n\n.small {\n  min-width: 40px;\n  width: 40px;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n\n  img {\n    cursor: pointer;\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  a {\n    font-weight: bold;\n    text-decoration: none;\n  }\n\n  span {\n    text-decoration: underline;\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n}\n\n.bg {\n  background-color: var(--_00000020-background);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n\n.newClientContainer {\n  position: fixed;\n  background-color: var(--white-color);\n  padding-bottom: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: 80vh;\n  width: 80%;\n  overflow-y: scroll;\n  border-radius: 10px;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n\n\n\n\n\n\n  .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  p {\n    color: var(--black-color);\n    font-weight: 500;\n    margin: 0;\n  }\n\n  .plan {\n    padding-right: 30px;\n\n    span {\n      color: var(--black-color);\n    }\n  }\n\n  .inputContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  .input {\n    width: 100%;\n    padding-right: 40px;\n    box-sizing: border-box;\n  }\n\n  .icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 30px;\n    height: 20px;\n    pointer-events: none;\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    color: #717171;\n    gap: 8px;\n    margin-bottom: 30px;\n    padding: 10px 0;\n    border-bottom: 1px solid #ebebeb;\n\n    input,\n    select,\n    option {\n      padding: 10px;\n      border: none;\n      outline: none;\n      background-color: var(--f5-background);\n      border-radius: 4px;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      -ms-border-radius: 4px;\n      -o-border-radius: 4px;\n    }\n\n    select,\n    option {\n      color: var(--_75-color);\n    }\n  }\n\n\n\n  .btnOptionsContainer {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    align-items: center;\n    gap: 10px;\n\n    button {\n      padding: 10px 20px;\n      border-radius: 8px;\n      text-decoration: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n    }\n\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    text-decoration: underline;\n    color: var(--black-color);\n    font-weight: 600;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_gheKk`,
	"clientsHeader": `clientsHeader__aS1e`,
	"infoClient": `infoClient_qii41`,
	"arrowContainer": `arrowContainer_ypUuA`,
	"iconContainer": `iconContainer_g2iKh`,
	"clientInfo": `clientInfo_kziZi`,
	"contactInfo": `contactInfo_V39rx`,
	"info": `info_wA4oE`,
	"searchContainer": `searchContainer_cuzAo`,
	"button": `button_WKOzs`,
	"imgContainer": `imgContainer_xLk6W`,
	"rowState": `rowState_bqLwP`,
	"inputWrapper": `inputWrapper_CGKhI`,
	"searchInput": `searchInput_fuM32`,
	"searchIconsWrappers": `searchIconsWrappers_D6HA5`,
	"addButton": `addButton_UfDv5`,
	"table": `table_bofZt`,
	"name": `name_F4n_4`,
	"small": `small_YvEnD`,
	"actions": `actions_q47kF`,
	"transacciones": `transacciones_yhqE9`,
	"bg": `bg_tsWV_`,
	"newClientContainer": `newClientContainer_YIuwh`,
	"row": `row_wmnfp`,
	"plan": `plan_HKTrY`,
	"inputContainer": `inputContainer_uE7C1`,
	"input": `input_nsLgK`,
	"icon": `icon_Trtmt`,
	"btnOptionsContainer": `btnOptionsContainer_rPAT1`
};
export default ___CSS_LOADER_EXPORT___;
